import { render } from "./Start.vue?vue&type=template&id=2e3f4309&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=2e3f4309&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3f4309"]])

export default __exports__